import { Component } from '@angular/core';

@Component({
  selector: 'mtm-resize-indicator-icon',
  templateUrl: './mtm-resize-indicator-icon.component.html',
  styleUrl: './mtm-resize-indicator-icon.component.scss',
  standalone: false,
})
export class MtmResizeIndicatorIconComponent {}
